import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as RevenueService from '@/services/RevenueService';

export const useRevenue = (companyId?: string) =>
  useQuery({
    queryKey: ['revenue', companyId],
    queryFn: () => RevenueService.getRevenue(companyId),
  });

export const useSyncStripe = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: RevenueService.syncStripeData,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['revenue'] }),
  });
};
